import { render, staticRenderFns } from "./clientListItem.vue?vue&type=template&id=40e87656&scoped=true&"
import script from "./clientListItem.vue?vue&type=script&lang=js&"
export * from "./clientListItem.vue?vue&type=script&lang=js&"
import style0 from "./clientListItem.vue?vue&type=style&index=0&id=40e87656&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e87656",
  null
  
)

export default component.exports